import { FC } from "react";
import styled, { css } from "styled-components";
import SubHeadline from "components/corphurusato/parts/SubHeadline";

type Props = {
  result: Result;
};

const ResultArea: FC<Props> = ({ result }) => {
  return (
    <Root>
      <StyledSubHeadline label="試算結果" color={"#FBB42B"} />
      <SubContent>
        <MainResult>
          <MainResultLabel>寄附額</MainResultLabel>
          <MainResultAmount>
            <SpanYen>{result["寄付額"].toLocaleString()}</SpanYen>円
          </MainResultAmount>
        </MainResult>
        <SelfPay>
          <SelfPayItem>
            <SelfPayLabel>自己負担額</SelfPayLabel>
            <SelfPayAmount>
              <SpanYen>{result["自己負担額"].toLocaleString()}</SpanYen>円
            </SelfPayAmount>
          </SelfPayItem>
          <SelfPayItem>
            <SelfPayLabel>自己負担割合</SelfPayLabel>
            <SelfPayAmount>
              <SpanYen>{result["自己負担割合"]}</SpanYen>%
            </SelfPayAmount>
          </SelfPayItem>
        </SelfPay>
      </SubContent>

      <StyledSubHeadline label="控除内訳" color={"#FBB42B"} />
      <SubContent>
        <DetailArea>
          <Detail>
            <Total>
              <div>損金算入効果</div>
              <div>{result["損金算入効果"].toLocaleString()}</div>
            </Total>
            <Total>
              <div>税額控除</div>
              <div>{result["税額控除①"].toLocaleString()}</div>
            </Total>
            <CorpTax>
              <div>法人住民税</div>
              <div>{result["住民税"].toLocaleString()}</div>
            </CorpTax>
            <CorpTax>
              <div>法人税</div>
              <div>{result["法人税"].toLocaleString()}</div>
            </CorpTax>
            <CorpTax>
              <div>法人事業税</div>
              <div>{result["法人事業税"].toLocaleString()}</div>
            </CorpTax>
          </Detail>
        </DetailArea>
        <Credit>
          <tbody>
            <tr>
              <CreditGenerics rowSpan={3}>
                税額控除計算
                <br />
                （法人住民税分）
              </CreditGenerics>
              <CreditLabel>法人税の2割</CreditLabel>
              <CreditAmount>{result["法人税の2割"].toLocaleString()}</CreditAmount>
            </tr>
            <tr>
              <CreditLabel>寄付額の4割</CreditLabel>
              <CreditAmount>{result["寄付額の4割"].toLocaleString()}</CreditAmount>
            </tr>
            <tr>
              <CreditSubTotalLabel>上記のいずれか最小金額</CreditSubTotalLabel>
              <CreditSubTotalAmount>{result["上記のいずれか最小金額①"].toLocaleString()}</CreditSubTotalAmount>
            </tr>
            <tr>
              <CreditGenerics rowSpan={4}>
                税額控除計算<br></br>
                （法人税分）
              </CreditGenerics>
              <CreditLabel>法人税の5%</CreditLabel>
              <CreditAmount>{result["法人税の5"].toLocaleString()}</CreditAmount>
            </tr>
            <tr>
              <CreditLabel>寄付額4割の補填</CreditLabel>
              <CreditAmount>{result["寄付額4割補填"].toLocaleString()}</CreditAmount>
            </tr>
            <tr>
              <CreditLabel>寄付額の1割</CreditLabel>
              <CreditAmount>{result["寄付額の1割"].toLocaleString()}</CreditAmount>
            </tr>
            <tr>
              <CreditSubTotalLabel>上記のいずれか最小金額</CreditSubTotalLabel>
              <CreditSubTotalAmount>{result["上記のいずれか最小金額②"].toLocaleString()}</CreditSubTotalAmount>
            </tr>
            <tr>
              <CreditGenerics rowSpan={3}>
                税額控除計算<br></br>
                （法人事業税分）
              </CreditGenerics>

              <CreditLabel>事業税の2割</CreditLabel>
              <CreditAmount>{result["事業税の2割"].toLocaleString()}</CreditAmount>
            </tr>
            <tr>
              <CreditLabel>寄付額の2割</CreditLabel>
              <CreditAmount>{result["寄付金額の2割"].toLocaleString()}</CreditAmount>
            </tr>
            <tr>
              <CreditSubTotalLabel>上記のいずれか最小金額</CreditSubTotalLabel>
              <CreditSubTotalAmount>{result["上記のいずれか最小金額③"].toLocaleString()}</CreditSubTotalAmount>
            </tr>
          </tbody>
        </Credit>
        <TotalCredit>
          <MainResultLabel>税額控除</MainResultLabel>
          <MainResultAmount>
            <SpanYen>{result["税額控除②"].toLocaleString()}</SpanYen>円
          </MainResultAmount>
        </TotalCredit>
        {/*<NoteBox>*/}
        {/*  税額控除額は寄付額に対して、自己負担割合が約4割程度になるときに最大化します。*/}
        {/*  <br />*/}
        {/*  下記の金額を超えて寄付を行うことが可能ですが、税目ごとに控除額の上限が設定されているため、税額控除額は増えません。*/}
        {/*</NoteBox>*/}
      </SubContent>
    </Root>
  );
};

export default ResultArea;

const StyledSubHeadline = styled(SubHeadline)`
  @media screen and (max-width: 960px) {
    margin: 30px 0 10px;
  }

  @media screen and (min-width: 961px) {
    margin: 60px 0 20px;
  }
`;

const SubContent = styled.div`
  @media screen and (min-width: 961px) {
    margin: 0 auto;
    width: 90%;
  }
`;

const Root = styled.div`
`;

const blockStyle = css`
  margin-right: auto;
  margin-left: auto;
  
  @media screen and (max-width: 960px) {
    width: 100%;
    max-width: 700px;
  }

  @media screen and (min-width: 961px) {
    width: 700px;
  }
`;

const MainResult = styled.div`
  background-color: #fff7e9;
  display: flex;
  font-weight: bold;
  justify-content: space-between;
  margin-top: 20px;
  padding: 20px 30px;
  ${blockStyle};

  @media screen and (max-width: 960px) {
    padding: 10px;
  }
`;

const MainResultLabel = styled.div`
  background-color: #fbb42b;
  color: white;
  display: flex;
  align-items: center;
  font-size: 1.25em;
  padding: 0 10px;
`;

const MainResultAmount = styled.div`
  font-size: 1.25em;
  display: inline-block;
  vertical-align: bottom;
`;

const SelfPay = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 20px auto;

  ${blockStyle};
`;

const SelfPayItem = styled.div`
  align-items: flex-end;
  display: flex;
  justify-content: space-between;
  width: 45%;
  vertical-align: bottom;

  @media screen and (max-width: 500px) {
    display: flex;
    flex-direction: column;
    align-items: start;
  }
`;

const SelfPayLabel = styled.div`
  @media screen and (max-width: 500px) {
    margin-bottom: 5px;
  }
`;

const SelfPayAmount = styled.div``;

const SpanYen = styled.span`
  font-size: 2em;
  box-sizing: border-box;
  margin: 0;
  font-weight: bold;
  display: inline-block;
`;

const DetailArea = styled.div`
  align-items: center;
  border: 2px solid #fbb42b;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  font-size: 1.25em;
  justify-content: center;
  margin: 20px 0;
  padding: 20px;
  width: 100%;

  @media screen and (max-width: 960px) {
    padding: 15px;
  }
`;

const Detail = styled.div`
  align-items: flex-end;
  border-bottom: 2px solid #fbb42b;
  display: flex;
  flex-direction: column;
  width: 60%;

  @media screen and (max-width: 960px) {
    max-width: 400px;
    width: 100%;
  }
`;

const Total = styled.div`
  border-bottom: 2px solid #fbb42b;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 5px 0;
  font-weight: bold;
`;

const CorpTax = styled.div`
  border-bottom: 1px solid #fbb42b;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 0;
  width: 90%;

  &:last-child {
    border-bottom: none;
  }
`;

const Credit = styled.table`
  border-collapse: collapse;
  width: 100%;
  margin: 20px 0;
  border-spacing: 2px;
  display: table;
  text-indent: initial;
`;

const cellStyle = css`
  padding: 10px;
`;

const CreditGenerics = styled.th`
  background-color: #fbb42b;
  color: white;
  border-bottom: 2px solid #fff;
  line-height: 1.428em;
  letter-spacing: 0;
  text-align: center;
  width: 25%;
  vertical-align: middle;
  ${cellStyle};
`;

const CreditLabel = styled.td`
  background-color: white;
  border-bottom: 1px solid #fbb42b;
  ${cellStyle};
`;

const CreditAmount = styled.td`
  border-bottom: 1px solid #fbb42b;
  text-align: right;
  ${cellStyle};
`;

const CreditSubTotalLabel = styled.td`
  background-color: #fff7e9;
  border-bottom: 2px solid #fbb42b;
  border-top: 2px solid #fbb42b;
  font-weight: bold;
  ${cellStyle};
`;

const CreditSubTotalAmount = styled.td`
  background-color: #fff7e9;
  border-bottom: 2px solid #fbb42b;
  border-top: 2px solid #fbb42b;
  font-weight: bold;
  text-align: right;
  ${cellStyle};
`;

const TotalCredit = styled.div`
  background-color: #fff7e9;
  display: flex;
  align-self: flex-end;
  justify-content: space-between;
  font-weight: bold;
  ${blockStyle};

  @media screen and (max-width: 960px) {
    margin: 20px auto;
    padding: 10px;
  }

  @media screen and (min-width: 961px) {
    margin: 30px auto;
    padding: 20px;
  }
`;

// const NoteBox = styled.div`
//   border: 2px solid #d6d6d6;
//   width: 100%;
//   line-height: 1.428em;
//   padding: 20px 18px;
//   margin: 20px 0;
//
//   @media screen and (min-width: 961px) {
//     margin: 20px auto;
//     width: 600px
//   }
// `;

export interface Result {
  寄付額: number;
  自己負担額: number;
  自己負担割合: number;
  損金算入効果: number;
  "税額控除①": number;
  住民税: number;
  法人税: number;
  地方法人税: number;
  法人事業税: number;
  法人税の2割: number;
  寄付額の4割: number;
  "上記のいずれか最小金額①": number;
  法人税の5: number;
  寄付額4割補填: number;
  寄付額の1割: number;
  "上記のいずれか最小金額②": number;
  事業税の2割: number;
  寄付金額の2割: number;
  "上記のいずれか最小金額③": number;
  "税額控除②": number;
}
